import { useEffect, useState } from "react";

const useRenderOptions = ({ data, handleOptionSelect, examMode }) => {
  const [options, setOptions] = useState([]);
  const [solutionInfo, setSolutionInfo] = useState();
  const [isCelebrate, setIsCelebrate] = useState(false);

  const handleOption = (opt, id) => {
    if (examMode === "false" || !examMode) {
      setSolutionInfo(data?.SolutionInfo);
      setIsCelebrate(opt == data?.CorrectAnswer?.[0] ? true : false);
    }
    handleOptionSelect(opt, id, data?.CorrectAnswer?.[0]);
  };

  useEffect(() => {
    if (data) {
      const questionOpt = Array.from({ length: 5 }, (_, i) => {
        const opt = data[`Opt${i + 1}`];
        return opt ? { text: opt, id: i + 1 } : null;
      }).filter(Boolean);

      setOptions(questionOpt);
      setSolutionInfo();
      setIsCelebrate();
    }
  }, [data]);

  return { options, isCelebrate, solutionInfo, handleOption };
};

export default useRenderOptions;
